import React, { useState } from 'react'

import Button from '../Button'
import ButtonGroup from 'constructicon/button-group'
import Heading from 'constructicon/heading'
import FlatModal from '../FlatModal'
import RichText from '../RichText'
import Section from 'constructicon/section'

const Confirm = ({
  cancelLabel,
  confirmLabel,
  onConfirm,
  message,
  tag: Tag,
  title,
  width,
  ...props
}) => {
  const [open, setOpen] = useState(false)

  return (
    <div>
      <Tag
        onClick={() => setOpen(true)}
        {...props}
      />
      <FlatModal
        closeIcon={false}
        contentLabel={title}
        isOpen={open}
        onRequestClose={() => setOpen(false)}
        spacing={1.5}
        width={width}
        textAlign='center'
      >
        {title && <Heading spacing={{ b: 1 }}>{title}</Heading>}
        {message && (
          <Section spacing={{ b: 1 }}>
            <RichText>{message}</RichText>
          </Section>
        )}
        <ButtonGroup>
          <Button
            onClick={() => {
              return Promise.resolve(onConfirm())
                .then(() => setOpen(false))
            }}>
            {confirmLabel}
          </Button>
          <Button
            background='shade'
            foreground='dark'
            onClick={() => setOpen(false)}>
            {cancelLabel}
          </Button>
        </ButtonGroup>
      </FlatModal>
    </div>
  )
}

Confirm.defaultProps = {
  confirmLabel: 'Yes',
  cancelLabel: 'No',
  tag: Button,
  title: 'Are you sure?',
  width: 12
}

export default Confirm
